import { message, } from 'antd';
import { MyStore } from 'kts-platform-frame/redux';
import { ActionBasic } from 'kts-scaffold-framework/modules';
import { history } from 'kts-platform-frame/routes';
import ModulesState from './Modules.State';
import { gettingStarted, guide } from 'src/api';

class ModulesAction extends ActionBasic<ModulesState> {
    public getAppList = async () => {
        const result = await gettingStarted.getGuideInfoList(this, {});
        if (result.res && !result.er) {
            this.modulesState.appList = result.res;
            this.setModulesState();
        }
    }

    public onChangeSelectCategory = async (e, item) => {
        const value = e.target.checked;
        let checkedCategoryIds: any[] = this.modulesState.checkedCategoryIds;
        let checkedCategoryData = this.modulesState.checkedCategoryData;
        let checkedAppIds = this.modulesState.checkedAppIds;
        if (value) {
            checkedCategoryIds.push(item.categoryId);
            checkedCategoryData.push(item);
            item.appInfoList.forEach(app => {
                if (!app.available) {
                    checkedAppIds.push(app.appId);
                }
            });
        } else {
            checkedCategoryIds = checkedCategoryIds.filter(categoryId => categoryId !== item.categoryId);
            checkedCategoryData = checkedCategoryData.filter(categoryData => categoryData.categoryId !== item.categoryId);
            item.appInfoList.forEach(app => {
                checkedAppIds = checkedAppIds.filter(appId => appId !== app.appId);
            });
        }
        this.modulesState.checkedAppIds = checkedAppIds;
        this.modulesState.checkedCategoryIds = checkedCategoryIds;
        this.modulesState.checkedCategoryData = checkedCategoryData;
        this.setModulesState();
    }

    /**
     * 根据选择的appId获取app信息列表 
     * @param 
     */
    public getCheckedAppInfo = () => {
        const checkedAppData = [];
        const checkedAppIds = this.modulesState.checkedAppIds;
        this.modulesState.appList.forEach(category => {
            const appInfoList = category.appInfoList || [];
            appInfoList.forEach(app => {
                if (checkedAppIds.includes(app.appId)) {
                    checkedAppData.push(app);
                }
            });
        });
        return checkedAppData;
    }

    public changeActiveModal = (visible: boolean) => {
        this.modulesState.activeModalVisible = visible;
        this.setModulesState();
    }

    /**
     * 全选当前协议列表
     */
    public checkcedAgreeAll = (e) => {
        const value = e.target.checked;
        if (value) {
            this.getCheckedAppInfo().forEach((item) => {
                this.modulesState.checkcedAgreeList.add(item.appId);
            });
        } else {
            this.modulesState.checkcedAgreeList.clear();
        }
        this.modulesState.isCheckcedAgreeAll = value;
        this.setModulesState();
    }

    /**
     * 选择协议方法，记录已勾选的协议列表
     *
     * @param {*} e
     * @param {*} value
     * @memberof ModulesAction
     */
    public checkcedAgreeListHandle = (e: any, value: any) => {
        const checkedFlag = e.target.value;
        if (checkedFlag) {
            this.modulesState.checkcedAgreeList.delete(value.appId);
        } else {
            this.modulesState.checkcedAgreeList.add(value.appId);
        }
        this.setModulesState(this.modulesState, () => {
            this.isCheckcedAgreeAllHandle();
        });
    }

    /**
     *
     * 判断当前协议是否已经全部勾选，如果已勾选，更新是否全部勾选协议状态isCheckcedAgreeAll
     * @memberof ModulesAction
     */
    public isCheckcedAgreeAllHandle = () => {
        const { checkedAppIds, checkcedAgreeList } = this.modulesState;
        this.modulesState.isCheckcedAgreeAll = checkedAppIds.every(appId => checkcedAgreeList.has(appId));
        this.setModulesState();
    }

    /** 监听 激活提示框 check按钮 */
    public onChangeCheck = (e) => {
        this.modulesState.isReadCheckd = e.target.checked;
        this.setModulesState();
    }

    /** 体验新版FA TMGP */
    public intoHome = async () => {
        const { user } = MyStore.instance.getState();
        const res = await guide.updateGuideVersion(this, {
            guideVersion: this.modulesState.GUIDE_VERSION,
            gUserId: user.userInfo.gUserId,
        });
        if (!res.er && res.res) {
            history.push(`/workbench/m/Kingxunlian.NewsFeed`);
        }
    }

    /** 获取激活appId 包括选中分类下默认激活的app */
    public getDefaultActiveAppList = () => {
        const defaultAppIds = [];
        const { checkedCategoryIds, appList } = this.modulesState;
        appList.map(category => {
            if (checkedCategoryIds.includes(category.categoryId)) {
                const appInfoList = category.appInfoList || [];
                appInfoList.forEach(app => {
                    if (app.available) {
                        defaultAppIds.push(app.appId);
                    }
                });
            }
        });
        return defaultAppIds;
    }

    public getCheckedAppKey = () => {
        const { checkedAppIds } = this.modulesState;
        const checkedAppData = [];
        this.modulesState.appList.forEach(category => {
            const appInfoList = category.appInfoList || [];
            appInfoList.forEach(app => {
                if (checkedAppIds.includes(app.appId)) {
                    checkedAppData.push(app.appKey);
                }
            });
        });
        return checkedAppData;
    }

    /**
     *  批量激活/申请应用
     */
    public appInstanceActivate = async (usertype) => {
        const { checkcedAgreeList } = this.modulesState;
        if (usertype === 'COMMON_USER') {
            const checkedAppData = this.getCheckedAppKey();
            const result = await gettingStarted.applyActivateGuideApp(this, { appKeys: checkedAppData });
            if (result.er) {
                message.error('申请失败！');
                return;
            }
            message.success('已成功申请！');
        } else {
            const defaultAppIds = this.getDefaultActiveAppList();
            const result = await gettingStarted.activateGuideApp(this,
                {
                    activeAppIdList: defaultAppIds,
                    unActiveAppIdList: [...checkcedAgreeList],
                });
            if (result.er) {
                message.error('激活失败！');
                return;
            }
            message.success(result.res);
        }
        this.intoHome();
        // this.modulesState.activeModalVisible = false;
        // this.modulesState.isReadCheckd = false;
        // this.modulesState.isCheckedAll = false;
        // this.modulesState.isCheckcedAgreeAll = false;
        // this.modulesState.checkcedAgreeList.clear();
        // this.modulesState.checkedAppIds = [];
        // this.modulesState.checkedCategoryIds = [];
        // this.modulesState.checkedCategoryData = [];
        // this.setModulesState();
        // this.getAppList();
    }
}

export default new ModulesAction();


// WEBPACK FOOTER //
// ./src/display/platform/GettingStarted/Modules.Action.ts